import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { useCampaignContestSort } from '@pages/Traders-Room/Campaign-Results/Contest/hooks/useCampaignContestSort'

import { useDateFilterWriteContext } from '@context/DateFilterContext'

import { PageQuery } from '@utils/ApiClient'

import { FilterQueryProps } from '@model/FilterFields'

const initialQuery = {}

export const useCampaignContestSearch = (sort: ReturnType<typeof useCampaignContestSort>) => {
  const { sort: sortId, sortOrder } = sort
  const location = useLocation()
  const { clearFilter } = useDateFilterWriteContext()
  const [search, setSearch] = useState<FilterQueryProps>(initialQuery)
  const [pageQuery, setPageQuery] = useState<PageQuery>({ sort: sortId, sortOrder })

  useEffect(() => {
    setSearch(initialQuery)
  }, [location.pathname])

  const clearSearch = (callback: () => void) => {
    callback()
    setSearch(initialQuery)
    clearFilter()
  }

  return { clearSearch, search, setSearch, pageQuery, setPageQuery }
}
